<div id="dashboard" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center sm:w-auto">
      <div class="flex sm:justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Your Maintenance Requests</div>
      <div class="bg-starburst-orange p-2 text-xl sm:text-xl">
        <div>We are rebuilding the maintenance request feature on our site. We apologize for the inconvenience. In the meantime, to create a maintenance request,
           please download the Tricon mobile app, or call us at <u><a [href]="'tel:' + triconPhoneNumber">{{triconPhoneNumberDotFormat}}</a></u>.</div>
        <div class="flex-col sm:flex sm:flex-row sm:justify-center">
          <div class="flex justify-center m-2">
            <a href="{{appStoreUrl}}">
              <img src="../../assets/svg/app-store.svg">
            </a>
          </div>
          <div class="flex justify-center m-2">
            <a href="{{googlePlayUrl}}">
              <img src="../../assets/svg/google-play.svg">
            </a>
          </div>
        </div>
    </div>
  </div>
</div>
<div *ngIf="errorMessage!=null" class="alert alert-danger text-center">
  {{ errorMessage }}
</div>
